'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _vuex = require('vuex');

var _cart = require('../../components/cart');

var _cart2 = _interopRequireDefault(_cart);

var _synch = require('../../components/synch');

var _synch2 = _interopRequireDefault(_synch);

var _vueScrollto = require('vue-scrollto');

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _StepTooltip = require('./StepTooltip');

var _StepTooltip2 = _interopRequireDefault(_StepTooltip);

var _cartDrawer = require('../../global/cart-drawer');

var _cartDrawer2 = _interopRequireDefault(_cartDrawer);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "Step1",

  components: {
    StepTooltip: _StepTooltip2.default
  },

  computed: Object.assign({}, (0, _vuex.mapState)({
    lenses: function lenses(state) {
      return state.prescription.lenses;
    },
    activeLenses: function activeLenses(state) {
      return state.prescription.activeLenses;
    },
    activePrescription: function activePrescription(state) {
      return state.prescription.activePrescription;
    },
    nonPrescriptionLens: function nonPrescriptionLens(state) {
      return state.prescription.nonPrescriptionLens;
    },
    options: function options(state) {
      return state.prescription.options;
    },
    finalLens: function finalLens(state) {
      return state.prescription.finalLens;
    },
    frame: function frame(state) {
      return state.prescription.frame;
    },
    finalVariant: function finalVariant(state) {
      return state.prescription.finalVariant;
    },
    totalPrice: function totalPrice(state) {
      return state.prescription.totalPrice;
    },
    cms: function cms(state) {
      return state.prescription.cms.step1;
    },
    cancelButton: function cancelButton(state) {
      return state.prescription.cms.global.cancel_button;
    },
    addToCartButton: function addToCartButton(state) {
      return state.prescription.cms.global.add_to_cart;
    },
    ssisPrescriptions: function ssisPrescriptions(state) {
      return state.prescription.prescriptions;
    },
    ssisGrabPrescriptions: function ssisGrabPrescriptions(state) {
      return state.prescription.grabPrescriptions;
    }
  }), {
    cylRulesLeft: function cylRulesLeft() {
      return this.activeGroup('bifocal') && Number(this.activePrescription.left.sph) >= 0 && Number(this.activePrescription.left.sph) <= 2 || this.activeGroup('progressive') && Number(this.activePrescription.left.sph) >= -2 && Number(this.activePrescription.left.sph) <= 2;
    },
    cylRulesRight: function cylRulesRight() {
      return this.activeGroup('bifocal') && Number(this.activePrescription.right.sph) >= 0 && Number(this.activePrescription.right.sph) <= 2 || this.activeGroup('progressive') && Number(this.activePrescription.right.sph) >= -2 && Number(this.activePrescription.right.sph) <= 2;
    },
    disabledRule: function disabledRule() {
      return this.activePrescription.type === '';
    },
    showPastPrescription: function showPastPrescription() {
      return this.ssisPrescriptions.length > 0;
    },
    continueRules: function continueRules() {
      var nextStep = true;
      if (this.showFormState) {
        nextStep = this.disabledRule;
      } else if (this.showFormStateB) {
        nextStep = this.disabledRule;
      } else if (this.showFormStateC) {
        nextStep = this.disabledRule;
      } else if (this.showPastPrescriptions) {
        nextStep = this.activePrescriptionId === '';
      } else if (this.showGrabbedPrescriptions) {
        nextStep = this.activePrescriptionId === '';
      } else {
        nextStep = Object.keys(this.finalLens).length === 0;
      }
      return nextStep;
    },
    continueButtonContent: function continueButtonContent() {
      var content = Object.keys(this.finalLens).length > 0 ? this.addToCartButton : this.cms.buttons.confirm_prescription;
      return content;
    }
  }),

  data: function data() {
    var _JSON$parse = JSON.parse(document.getElementById('ShopifyData').innerHTML),
        customer = _JSON$parse.customer;

    return {
      actionSelected: false,
      showFormState: false,
      showFormStateB: false,
      showFormStateC: false,
      showPastPrescriptions: false,
      showGrabbedPrescriptions: false,
      activePrescriptionId: '',
      activeLimits: { sphMin: 0, sphMax: 0, cylMin: 0, cylMax: 0 },
      groupLimits: [{ title: 'distance', sphMin: -12, sphMax: 10, cylMin: -6, cylMax: 6, axisMin: 0, axisMax: 180, ipdMin: 20, ipdMax: 40, phMin: -6, phMax: 6 }, { title: 'reading', sphMin: -12, sphMax: 10, cylMin: -6, cylMax: 6, axisMin: 0, axisMax: 180, ipdMin: 20, ipdMax: 40, phMin: -6, phMax: 6 }, { title: 'bifocal', sphMin: -6, sphMax: 6, cylMin: -4, cylMax: 4, axisMin: 0, axisMax: 180, ipdMin: 20, ipdMax: 40, phMin: -6, phMax: 6, addMin: 1, addMax: 3 }, { title: 'progressive', sphMin: -6, sphMax: 4, cylMin: -4, cylMax: 6, axisMin: 0, axisMax: 180, ipdMin: 20, ipdMax: 40, phMin: -6, phMax: 6, addMin: 1, addMax: 3 }],
      productMap: [{ ids: [4816604201014, 4816604528694, 4816608821302, 4816609738806], sphMin: 0, sphMax: 0, cylMin: 0, cylMax: 0, group: 'distance', rank: 1 }, { ids: [4816305029174, 4816334520374, 4816340254774, 4816345235510, 4816348414006], sphMin: -4, sphMax: 3, cylMin: -2, cylMax: 2, group: 'distance', rank: 2 }, { ids: [4816379412534, 4816389537846, 4830336548918], sphMin: -6, sphMax: -4.25, cylMin: -2, cylMax: 2, group: 'distance', rank: 3 }, { ids: [4816402350134], sphMin: -8, sphMax: -6.25, cylMin: -2, cylMax: 2, group: 'distance', rank: 4 }, { ids: [4816409362486], sphMin: 3.25, sphMax: 6, cylMin: -2, cylMax: 2, group: 'distance', rank: 5 }, { ids: [4816417095734, 4816420929590, 4816425451574, 4816430956598, 4816440164406], sphMin: -8, sphMax: 7.50, cylMin: -6, cylMax: 6, group: 'distance', rank: 6 }, { ids: [4816444260406, 4816453009462, 4816456220726], sphMin: -10, sphMax: -8.25, cylMin: -6, cylMax: 6, group: 'distance', rank: 7 }, { ids: [4816467492918], sphMin: -12, sphMax: -12.25, cylMin: -6, cylMax: 6, group: 'distance', rank: 8 }, { ids: [4816471294006, 4816493838390, 4816495870006], sphMin: 7.75, sphMax: 10, cylMin: -6, cylMax: 6, group: 'distance', rank: 9 }, { ids: [4816556982326, 4816557080630, 4816557178934, 4816557342774, 4816557441078], sphMin: -4, sphMax: 3, cylMin: -2, cylMax: 2, group: 'reading', rank: 1 }, { ids: [4816557572150, 4816557768758, 4830334386230], sphMin: -6, sphMax: -4.25, cylMin: -2, cylMax: 2, group: 'reading', rank: 2 }, { ids: [4816557899830], sphMin: -8, sphMax: -6.25, cylMin: -2, cylMax: 2, group: 'reading', rank: 3 }, { ids: [4816558030902], sphMin: 3.25, sphMax: 6, cylMin: -2, cylMax: 2, group: 'reading', rank: 4 }, { ids: [4816558161974, 4816558391350, 4816558456886, 4816558653494, 4816558719030], sphMin: -8, sphMax: 7.50, cylMin: -6, cylMax: 6, group: 'reading', rank: 5 }, { ids: [4816558882870, 4816558948406, 4816559145014], sphMin: -10, sphMax: -8.25, cylMin: -6, cylMax: 6, group: 'reading', rank: 6 }, { ids: [4816559243318], sphMin: -12, sphMax: -12.25, cylMin: -6, cylMax: 6, group: 'reading', rank: 7 }, { ids: [4816559308854, 4816559505462, 4816559538230], sphMin: 7.75, sphMax: 10, cylMin: -6, cylMax: 6, group: 'reading', rank: 8 }, { ids: [4496866476086, 4496865984566], sphMin: 0, sphMax: 2, cylMin: 0, cylMax: 0, group: 'bifocal', rank: 1 }, { ids: [4496865624118, 4496864903222], sphMin: -6, sphMax: 6, cylMin: -4, cylMax: 4, group: 'bifocal', rank: 2 }, { ids: [4496860282934, 4496853041206], sphMin: -2, sphMax: 2, cylMin: 0, cylMax: 0, group: 'progressive', rank: 1 }, { ids: [4496851402806, 4496848257078, 4493416923190, 4596967473206], sphMin: -7, sphMax: 4, cylMin: -6, cylMax: 6, group: 'progressive', rank: 2 }],
      mobileForm: this.isMobile() ? true : false,
      customer: customer
    };
  },

  methods: Object.assign({}, (0, _vuex.mapMutations)(['setActiveLenses', 'setPrescription', 'setFinalLens', 'setFinalVariant', 'setStep', 'setFrameOptions', 'setGrabPrescriptions']), {
    setLens: function setLens() {
      this.actionSelected = true;
      this.hideForm();
      this.hideFormB();
      this.hideData();
      this.setFinalLens(this.nonPrescriptionLens);
      this.setFinalVariant(this.nonPrescriptionLens.variants[0]);
    },
    showForm: function showForm() {
      this.showFormState = true;
      this.actionSelected = true;
    },
    hideForm: function hideForm() {
      this.showFormState = false;
    },
    showData: function showData() {
      this.showPastPrescriptions = true;
      this.actionSelected = true;
    },
    hideData: function hideData() {
      this.showPastPrescriptions = false;
    },
    showFormB: function showFormB() {
      this.showFormStateB = true;
      this.actionSelected = true;
    },
    showFormC: function showFormC() {
      this.showFormStateC = true;
      this.actionSelected = true;
    },
    hideFormB: function hideFormB() {
      this.showFormStateB = false;
    },
    hideFormC: function hideFormC() {
      this.showFormStateC = false;
      this.showGrabbedPrescriptions = false;
    },
    isMobile: function isMobile() {
      return window.innerWidth < 768;
    },
    onResize: function onResize() {
      this.mobileForm = this.isMobile() ? true : false;
    },
    formattedDate: function formattedDate(ssisDate) {
      var date = new Date(ssisDate);
      return date.toLocaleDateString('en-US');
    },
    addToCart: function addToCart() {
      var customer = this.customer;

      var data = {
        frameId: this.frame.selectedVariant.id,
        lensId: this.finalVariant.id,
        lensProps: { '_item_type': 'specs_lens' },
        frameProps: { '_item_type': 'specs_frame', '_prescription': 'false' },
        customer: customer
      };
      var cartInstance = new _cart2.default(data);

      // Add to cart
      cartInstance.addLens();

      // Emit state and expand cart drawer
      this.$emit('add-to-cart');
      (0, _cartDrawer2.default)(true);
      document.querySelector('.cart-drawer').classList.add('expanded');
    },
    showPrescriptionForm: function showPrescriptionForm() {
      var element = this.$refs.presForm;
      var options = { container: '.PrescriptionLensData' };

      this.setFinalLens({});
      this.showForm();
      this.hideFormB();
      this.hideFormC();
      this.hideData();
      _vueScrollto2.default.scrollTo(element, 300, options);
    },
    showNonPrescriptionForm: function showNonPrescriptionForm() {
      var element = this.$refs.nonPresForm;
      var options = { container: '.PrescriptionLensData' };

      this.setFinalLens({});
      this.showFormC();
      this.hideForm();
      this.hideFormB();
      this.hideData();
      this.filterLensesByGroup('distance');
      _vueScrollto2.default.scrollTo(element, 300, options);
    },
    formatPrescriptionStore: function formatPrescriptionStore(store, date) {
      var prxStore = store.toLowerCase();
      var dateLaunch = 20201031;
      var dateCreated = (0, _moment2.default)(date).format("YYYYMMDD");

      // Virtual Store branch renaming
      if (prxStore == "virtual store" || prxStore == "virtual store international") {
        if (dateCreated > dateLaunch) {
          prxStore = "sunniesstudios.com";
        } else {
          prxStore = "sunniesspecs.com";
        }
      }

      return prxStore;
    },
    showGrabPrescriptions: function showGrabPrescriptions() {
      var element = this.$refs.presGrab;
      var options = { container: '.PrescriptionLensData' };

      this.setFinalLens({});
      this.showFormB();
      this.hideForm();
      this.hideFormC();
      this.hideData();
      _vueScrollto2.default.scrollTo(element, 300, options);
    },
    activeGroup: function activeGroup(lensGroup) {
      return lensGroup === this.activePrescription.type;
    },
    inactiveState: function inactiveState(lensGroup) {
      return lensGroup !== this.activePrescription.type && this.activePrescription.type !== '';
    },
    imposeGroupLimits: function imposeGroupLimits(groupLimits, lensGroup) {
      // Check the lens group
      // Reset entered data, to ensure it fits within range
      if (lensGroup != "progressive") {
        this.activePrescription.left = { sph: 0, cyl: 0.00, axis: 0, add: 0, ipd: 20, ph: 0 };
        this.activePrescription.right = { sph: 0, cyl: 0.00, axis: 0, add: 0, ipd: 20, ph: 0 };
      } else {
        this.activePrescription.left = { sph: 0, cyl: 0.00, axis: 0, add: 0, ipd: 20, ph: 14 };
        this.activePrescription.right = { sph: 0, cyl: 0.00, axis: 0, add: 0, ipd: 20, ph: 14 };
      };

      // Update form based on chosen lens type range limits
      this.activeLimits = groupLimits;
    },
    formIsValid: function formIsValid() {
      var generalError = '';
      var enabledFormFields = document.querySelectorAll('#prescriptionForm select:not([disabled]) option:checked');

      // Remove any error statues
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = enabledFormFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          field.classList.remove('error');
        }

        // Ensure form group type has been selected
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (enabledFormFields.length < 1) {
        generalError = 'Please select a vision type.';
        this.$emit('error-message', generalError);
        return false;
      } else {
        var isValid = true;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = enabledFormFields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _field = _step2.value;

            if (_field.value.length < 1) {
              isValid = false;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = enabledFormFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _field2 = _step3.value;

            if (_field2.value.length < 1) {
              _field2.classList.add('error');
            } else {
              _field2.classList.remove('error');
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        if (!isValid) {
          generalError = 'All highlighted fields are required.';
          this.$emit('error-message', generalError);
        }
        return isValid;
      }
    },
    formIsValidB: function formIsValidB() {
      var generalError = '';
      var enabledFormFields = document.querySelectorAll('#nonPrescriptionForm input:not([disabled])');

      // Remove any error statues
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = enabledFormFields[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var field = _step4.value;

          field.classList.remove('error');
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      var isValid = true;
      return isValid;
    },
    formIsValidC: function formIsValidC() {
      var generalError = '';
      var enabledFormFields = document.querySelectorAll('#grabPrescriptionForm input:not([disabled])');

      // Remove any error statues
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = enabledFormFields[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var field = _step5.value;

          field.classList.remove('error');
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var isValid = true;
      return isValid;
    },
    imposeFieldLimits: function imposeFieldLimits() {
      var activePrescription = this.activePrescription;
      var activeLimits = this.activeLimits;
      var keys = Object.keys(activePrescription);
      var limitKeys = Object.keys(activeLimits);

      // Iterate over prescription left and right eye data
      keys.forEach(function (key) {
        if ((0, _typeof3.default)(activePrescription[key]) === 'object') {
          var subkeys = Object.keys(activePrescription[key]);

          // Iterate over every key in left/right eye objects
          subkeys.forEach(function (subkey) {
            var stringCheck = subkey;

            // Iterate over 'activeLimits' - the max/min values imposed by selecting a lens type
            limitKeys.forEach(function (limit) {

              // As long as it is not empty
              if (activePrescription[key][subkey] !== '') {

                // As long as it is not empty
                // if (activePrescription[key][subkey] !== '') {
                //   if (
                //     // Respective value exeeds max/min
                //     // Reset to closest max/min value
                //     ((limit === `${stringCheck}Min`) && (activePrescription[key][subkey] < activeLimits[limit])) ||
                //     ((limit === `${stringCheck}Max`) && (activePrescription[key][subkey] > activeLimits[limit]))
                //   ) {
                //     const resetLimit = (activePrescription[key][subkey] < activeLimits[limit]) ? `${stringCheck}Min` : `${stringCheck}Max`
                //     if ((subkey !== 'ipd') && (subkey !== 'axis')) {
                //       activePrescription[key][subkey] = parseFloat(activeLimits[resetLimit]).toFixed(2)
                //     } else {
                //       activePrescription[key][subkey] = parseInt(activeLimits[resetLimit]).toFixed(0)
                //     }
                //   } else {
                //     // Has 2 decimal points, visually and programatically
                //     if ((subkey !== 'ipd') && (subkey !== 'axis')) {
                //       activePrescription[key][subkey] = parseFloat(activePrescription[key][subkey]).toFixed(2)
                //     } else {
                //       activePrescription[key][subkey] = parseInt(activePrescription[key][subkey]).toFixed(0)
                //     }
                //   }

              }
            });
          });
        }
      });

      // Update the prescription with values - ensures 2-decimals on applicable fields
      this.setPrescription(activePrescription);
    },
    filterLensesByGroup: function filterLensesByGroup(lensGroup, prx_group_type) {
      var options = this.options;
      var activeLenses = this.lenses.filter(function (lens) {
        return lens.tags.includes(lensGroup);
      });
      var groupLimits = this.groupLimits.filter(function (group) {
        return group.title === lensGroup;
      })[0];

      this.activePrescription.type = lensGroup;
      options.step1.name = 'Vision: ' + lensGroup[0].toUpperCase() + lensGroup.slice(1);
      options.step1.cost = 'free';

      options.step2.cost = 0;
      options.step3.cost = 0;

      this.imposeGroupLimits(groupLimits, lensGroup);
      this.setActiveLenses(activeLenses);

      // If prescription has been "grabbed"
      if (prx_group_type == "grab-prescription") {

        var curRightSPH = (0, _jquery2.default)('.gp-button.active').data('prx-right-sph');
        var curRightCYL = (0, _jquery2.default)('.gp-button.active').data('prx-right-cyl');
        var curRightAXIS = (0, _jquery2.default)('.gp-button.active').data('prx-right-axis');
        var curRightADD = (0, _jquery2.default)('.gp-button.active').data('prx-right-add');
        var curRightIPD = (0, _jquery2.default)('.gp-button.active').data('prx-right-ipd');
        var curRightPH = (0, _jquery2.default)('.gp-button.active').data('prx-right-ph');
        var curLeftSPH = (0, _jquery2.default)('.gp-button.active').data('prx-left-sph');
        var curLeftCYL = (0, _jquery2.default)('.gp-button.active').data('prx-left-cyl');
        var curLeftAXIS = (0, _jquery2.default)('.gp-button.active').data('prx-left-axis');
        var curLeftADD = (0, _jquery2.default)('.gp-button.active').data('prx-left-add');
        var curLeftIPD = (0, _jquery2.default)('.gp-button.active').data('prx-left-ipd');
        var curLeftPH = (0, _jquery2.default)('.gp-button.active').data('prx-left-ph');

        this.activePrescription.right = { sph: curRightSPH, cyl: curRightCYL, axis: curRightAXIS, add: curRightADD, ipd: curRightIPD, ph: curRightPH };
        this.activePrescription.left = { sph: curLeftSPH, cyl: curLeftCYL, axis: curLeftAXIS, add: curLeftADD, ipd: curLeftIPD, ph: curLeftPH };
      }

      this.setPrescription(this.activePrescription);
      this.setFrameOptions(options);
    },
    filterLensesByData: function filterLensesByData() {
      var _this = this;

      var reducedActiveLenses = [];

      // Use product map to get products that correspond to left eye user input
      var leftProducts = this.productMap.filter(function (group) {
        return group.sphMin <= Number(_this.activePrescription.left.sph).toFixed(2) && group.sphMax >= Number(_this.activePrescription.left.sph).toFixed(2) && group.cylMin <= Number(_this.activePrescription.left.cyl).toFixed(2) && group.cylMax >= Number(_this.activePrescription.left.cyl).toFixed(2) && _this.activePrescription.type === group.group;
      })[0];

      // Use product map to get products that correspond to right eye user input
      var rightProducts = this.productMap.filter(function (group) {
        return group.sphMin <= Number(_this.activePrescription.right.sph).toFixed(2) && group.sphMax >= Number(_this.activePrescription.right.sph).toFixed(2) && group.cylMin <= Number(_this.activePrescription.right.cyl).toFixed(2) && group.cylMax >= Number(_this.activePrescription.right.cyl).toFixed(2) && _this.activePrescription.type === group.group;
      })[0];

      // Ensure both eyes return valid products
      if (leftProducts && rightProducts) {
        // Get selected lens product groups by comparing product map "rank."
        // The higher rank takes precidence.
        var selectedLensGroup = leftProducts.rank > rightProducts.rank ? leftProducts : rightProducts;
        var selectedLensGroupIds = selectedLensGroup.ids;

        // Filter active lenses by the IDs found using the product map
        this.activeLenses.forEach(function (product) {
          if (selectedLensGroupIds.includes(product.id)) {
            reducedActiveLenses.push(product);
          }
        });
      } else {
        var rankArray = this.productMap.map(function (group) {
          return group.rank;
        });
        var highestRank = Math.max.apply(Math, (0, _toConsumableArray3.default)(rankArray));
        var reducedActiveLensIds = this.productMap.filter(function (group) {
          return group.rank === highestRank && group.group === _this.activePrescription.type;
        })[0].ids;
        this.activeLenses.forEach(function (product) {
          if (reducedActiveLensIds.includes(product.id)) {
            reducedActiveLenses.push(product);
          }
        });
      }

      // Update active lenses with reduced product data
      this.setActiveLenses(reducedActiveLenses);
    },
    selectOptions: function selectOptions() {
      var _this2 = this;

      var element = document.querySelector('.PrescriptionHeader');
      var options = { container: '.PrescriptionLensData' };

      _vueScrollto2.default.scrollTo(element, 300, options);
      setTimeout(function () {
        if (_this2.finalLens !== {} && _this2.finalLens.title && !_this2.showFormState) {
          _this2.addToCart();
        } else if (_this2.showPastPrescriptions) {
          _this2.setStep(2);
        } else if (_this2.showGrabbedPrescriptions && _this2.formIsValidC()) {
          _this2.filterLensesByData();
          _this2.setStep(2);
        } else if (!_this2.showFormStateC && _this2.formIsValid()) {
          _this2.filterLensesByData();
          _this2.setStep(2);
        } else if (!_this2.showFormState && _this2.formIsValidB()) {
          _this2.filterLensesByData();
          _this2.setStep(2);
        }
      }, 300);
    },
    showPastPrescriptionButtons: function showPastPrescriptionButtons() {
      var element = this.$refs.presData;

      this.setFinalLens({});
      this.hideForm();
      this.hideFormB();
      this.hideFormC();
      this.showData();
    },
    setPastPrescription: function setPastPrescription(ssisData) {
      var options = this.options;
      var activeLenses = this.lenses.filter(function (lens) {
        return lens.tags.includes(ssisData.type);
      });

      this.activePrescriptionId = ssisData.id;
      options.step1.name = 'Vision: ' + ssisData.type[0].toUpperCase() + ssisData.type.slice(1);
      options.step1.cost = 'free';

      // Clear any visual options if user has backtracked
      options.step2.cost = 0;
      options.step3.cost = 0;

      this.setActiveLenses(activeLenses);
      this.setPrescription(ssisData);
      this.setFrameOptions(options);
      this.filterLensesByData();
    },
    synchProfiles: function synchProfiles() {
      var customer = this.customer;

      var data = {
        emailAddress: document.querySelector('#GPEMAIL').value,
        customer: customer
      };
      var element = this.$refs.presGrabData;
      var options = { container: '.PrescriptionLensData' };
      var synchInstance = new _synch2.default(data);

      synchInstance.grabPrescriptions();
      this.showGrabbedPrescriptions = true;

      setTimeout(function () {
        _vueScrollto2.default.scrollTo(element, 300, options);
      }, 1500);
    }
  }),

  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener('resize', _this3.onResize);
    });
  },

  watch: {
    activePrescription: {
      deep: true,
      handler: function handler() {
        var _this4 = this;

        if (this.showFormState) {
          setTimeout(function () {
            _this4.imposeFieldLimits();
          }, 500);
        }
      }
    }
  }
};